module.exports = __webpack_public_path__ + "img/camera.19a54509.svg";